
  import { css } from 'lit';
  export const styles = css`:host{--color: var(--ig-label-color, var(--ig-gray-900));--ig-theme: fluent;--ig-theme-variant: light}`;
  